var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"鱼骨图","visible":_vm.fishVisible,"before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.fishVisible=$event}}},[_c('Jtopo',{attrs:{"fishboneData":_vm.fishboneData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }